var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeopleAskIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-ui-name": "ChatQuestion",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    "aria-hidden": "true",
    "data-name": "ChatQuestion",
    "data-group": "m"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.163 5.999c-.35.292-.487.675-.562 1.001H7.4c0-.55.194-1.023.652-1.401.459-.379.683-.587.683-.846 0-.413-.088-.78-.734-.78s-.797.58-.797.972H6C6 3.873 6.897 3 8 3c1.253 0 2 .655 2 1.753 0 .59-.367.876-.688 1.128l-.149.118zM8 9a.75.75 0 100-1.5A.75.75 0 008 9z",
    shapeRendering: "geometricPrecision"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.004 0h12.043A1.005 1.005 0 0115 1.001v10.01a1 1 0 01-1.004 1.002H6.36l-3.803 2.803a1.006 1.006 0 01-1.004.09 1.003 1.003 0 01-.552-.89V1a1 1 0 011.003-1zm4.074 10.01h6.965V2.022H3.007v10.01l2.469-1.821c.174-.13.385-.2.602-.2z",
    shapeRendering: "geometricPrecision"
  })));
}
export default SvgPeopleAskIcon;